
export const populateSalesTotalChartData = (salesTotalChartData, newData) => {
    salesTotalChartData.value = newData?.total?.total || 0
}
